export default function locateInSurveyStore(where, currentStep){
    for(let e of Object.keys(where).reverse()){
        if(e <= currentStep){
            return where[e];
        }
    }
}